/**
 * Grupos de energía con exclusividad mutua entre "combined" y conceptos separados.
 * Si se usa combined en un mes, no se pueden usar los separados en otros meses del mismo año (y viceversa).
 */
export const ENERGY_CONFLICT_GROUPS = [
  {
    combined: "electricity_standard_combined",
    separate: [
      "electricity_standard_domestic",
      "electricity_standard_production",
    ],
  },
  {
    combined: "renewable_energies_ppa_combined",
    separate: [
      "renewable_energies_ppa_domestic",
      "renewable_energies_ppa_production",
    ],
  },
  {
    combined: "renewable_energies_on_site_combined",
    separate: [
      "renewable_energies_on_site_domestic",
      "renewable_energies_on_site_production",
    ],
  },
  {
    combined: "natural_gas_combined",
    separate: ["natural_gas_production_operations", "natural_gas_domestic"],
  },
  {
    combined: "glp_combined",
    separate: ["glp_production_operations", "glp_domestic"],
  },
];

/**
 * Analiza todos los formularios del año y determina qué campos deben deshabilitarse
 * por conflicto con datos de otros meses.
 *
 * @param {Array} yearForms - Todos los formularios de energía del sitio/año
 * @param {String|null} currentPeriod - Período actual (se excluye del análisis). Null para formularios nuevos.
 * @returns {Object} Mapa { fieldName: true } indicando campos que deben estar deshabilitados
 */
export function computeCrossMonthRestrictions(yearForms, currentPeriod = null) {
  const restrictions = {};

  const otherMonthsForms = currentPeriod
    ? yearForms.filter((f) => f.period !== currentPeriod)
    : yearForms;

  ENERGY_CONFLICT_GROUPS.forEach(({ combined, separate }) => {
    const hasCombinedInOtherMonths = otherMonthsForms.some(
      (form) => form[combined]?.value > 0
    );

    const hasSeparateInOtherMonths = otherMonthsForms.some((form) =>
      separate.some((fieldName) => form[fieldName]?.value > 0)
    );

    if (hasCombinedInOtherMonths) {
      separate.forEach((fieldName) => {
        restrictions[fieldName] = true;
      });
    }

    if (hasSeparateInOtherMonths) {
      restrictions[combined] = true;
    }
  });

  return restrictions;
}
